import { useNavigate } from "react-router-dom";
import IconButton from "../Button/IconButton";
import { useAppSelector } from "../../../data/store/store";
import { UserRole } from "../../Pages/User/user-role";
import BackButton from '../Button/BackButton';
import { LoginIcon } from "../Button/icons";
import { useContext } from "react";
import MessageContext from "../../../utils/messages/message-context";
import { Title } from "../Title/Title";

export default function Page({ component, requireLogin, title }:
    { component: JSX.Element, requireLogin?: boolean, title?: string }) {
    const messages = useContext(MessageContext);
    const role = useAppSelector(state => state.role);
    const navigate = useNavigate();

    if (requireLogin && role !== UserRole.Admin) {
        return (
            <div>
                <h3>{messages.REQUIRES_LOGIN}</h3>
                <div>
                    <BackButton />
                    <IconButton IconElement={LoginIcon} onClick={() => navigate('/login')}>
                        {messages.LOGIN}
                    </IconButton>
                </div>
            </div>
        );
    }

    return (
        <>
            {
                title && <Title>{title}</Title>
            }

            {component}
        </>
    );
}
